<template>
	<page enable-flex>
		<view-list work-type="2" :custom-view="{
			name: '工单管理',
			tabs,
			tabParam: val => ({status: val ? [val] : []})
		}" :search="{placeholder: '搜工单编号、产品'}">
			<template #default="{data, index}">
				<view-list-card :key="index" :data="data" @click="mp.navigateWeb('/aftersales/work/detail', {id: data.id})">
					<template #base>
						<div class="card-base-info flex">
							<div class="flex-grow">
								<div class="state flex-wrap">
									<c-state dict="afterSaleOrderStateDic" tag :value="data.status"></c-state>
									<c-state dict="serviceTypeDic" tag :value="data.service_type"></c-state>
								</div>
								<p class="title">{{data.customer_name}}</p>
							</div>
						</div>
					</template>

					<template #content>
						<c-field icon="tf-field" label="工单编号">{{data.order_number}}</c-field>
						<c-field icon="tf-field" label="负责人">{{data.charge_user_realname}}</c-field>
						<c-field icon="tf-field" label="参与人">{{data.group_user_realname ? data.group_user_realname.replaceAll(',', '、') : ''}}</c-field>
						<c-field icon="tf-field" label="预约时间">{{data.appointment_start_time}}</c-field>
						<c-field icon="tf-field" label="服务地址">{{data.customer_address}}</c-field>
						<member-icon v-if="data.charge_user_realname" class="person" circle :icon="data.charge_user_head_photo" :name="data.charge_user_realname" text></member-icon>
					</template>

					<template #bar>
						<div class="card-bar flex-center">
							<div class="card-bar-total flex-column">
								<p>产品件数</p>
								<strong>{{data.product_count}}件</strong>
							</div>
							<div class="card-bar-total flex-column">
								<p>预计服务时长</p>
								<strong>{{data.estimated_service_days}}天</strong>
							</div>
							<div class="flex-grow flex-end-center">
								<c-progress :rate="[data.completion_progress || 0, 1]" type="circle" size="0.92" color="#00A1E9">
									<template #text="{rate}">
										<span :style="{'color': 'var(--color-main)'}">{{rate.toFixed(0)}}%</span>
									</template>
								</c-progress>
							</div>
						</div>
					</template>

					<template #operate>
						<c-button v-if="data.evaluate_state == 1" @click="globalDialog('appraiseDetail', {props: {id: data.id}})">查看评价</c-button>
						<c-button @click="mp.navigateWeb('/aftersales/work/detail', {id: data.id})">查看详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'custom_aftersale_order',
		
		data() {
			return {
			}
		},

		computed: {
			...mapState(['afterSaleOrderStateDic']),

			tabs() {
				return this.afterSaleOrderStateDic.splice(1);
			}
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.person {
		position: absolute;
		right: .26rem;
		top: .8rem;
	}
</style>